/** The member names of an enum object, keyed by the integer Godot stores. */
/**
 * The member of `enumObject` that holds `value`, or null: for a setter that refuses an integer no member holds.
 *
 * @canonical An engine enum, held as an `as const` object in `godot/`
 */
export function enumMember(enumObject, value) {
    return Object.values(enumObject).includes(value) ? value : null;
}
/** Each member name by its integer, as a validator or an inspector names it. */
/* @__NO_SIDE_EFFECTS__ */
export function enumNamesByValue(enumObject) {
    return Object.freeze(Object.fromEntries(Object.entries(enumObject).map(([name, value]) => [value, name])));
}
/**
 * Each name in `names` turned by `label`, for a property whose hint prints an enum's names in
 * another form, so the label table still comes from the enum.
 */
/* @__NO_SIDE_EFFECTS__ */
export function relabelEnumNames(names, label) {
    return Object.freeze(Object.fromEntries(Object.entries(names).map(([value, name]) => [value, label(name)])));
}
/**
 * Each member's label by its integer, for a hint that spells the names with no rule to derive
 * them from. `labels` must name every member, so a member added to the enum fails the type check.
 */
/* @__NO_SIDE_EFFECTS__ */
export function labelEnumNames(enumObject, labels) {
    return Object.freeze(Object.fromEntries(Object.entries(enumObject).map(([name, value]) => [value, labels[name]])));
}
/**
 * The label of each listed flag by its bit: `prefix` before the member name, as the engine spells
 * the constant. For a bit-field hint that offers only some of the flags of an enum.
 */
/* @__NO_SIDE_EFFECTS__ */
export function flagLabels(flags, prefix, members) {
    return Object.freeze(Object.fromEntries(members.map((member) => [flags[member], `${prefix}${member}`])));
}
/** A `SPECIFIC_BONE` member as the PascalCase word a hint string prints, `SpecificBone`. */
/* @__NO_SIDE_EFFECTS__ */
export function pascalCaseLabel(name) {
    return name
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}
//# sourceMappingURL=enumNames.js.map